module.exports = __webpack_public_path__ + "static/23-Changes-41eeaf547d6b74d01721526a6f6533d8.png";